/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description': 'チームまたは管理者にサポートを依頼してください。',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title': 'この検索の結果を取得できませんでした'
};